import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import mixpanel from 'mixpanel-browser';

mixpanel.init('2174b77e1cad4680e3c0285a9de8e0b8', {
  debug: true,
  record_sessions_percent: 100 // Record 100% of all sessions for Session Replay
});

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
